import HighlightsInfoCards from './HighlightsInfoCards';

export default HighlightsInfoCards;
